/* TAJDEED THEME — Main JavaScript */
'use strict';

// ── LANGUAGE TOGGLE ───────────────────────────────────────────────────────────────────────
window.TajdeedLang = {
  current: localStorage.getItem('tajdeed-lang') || 'ar',

  set: function(lang) {
    this.current = lang;
    localStorage.setItem('tajdeed-lang', lang);
    var html = document.documentElement;
    html.classList.remove('lang-ar', 'lang-en');
    html.classList.add('lang-' + lang);
    html.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    html.setAttribute('lang', lang);
    // Update toggle buttons
    document.querySelectorAll('.lang-btn').forEach(function(btn) {
      btn.classList.toggle('active', btn.dataset.lang === lang);
    });
    // Update search placeholder
    var sp = document.getElementById('site-search-input');
    if (sp) {
      sp.placeholder = lang === 'ar'
        ? 'ابحث عن iPhone، Samsung، أكسسوارات...'
        : 'Search iPhone, Samsung, accessories...';
    }
    // Keep the KSA country-selector link pointed at the matching subfolder
    // (KSA has its own dedicated web presence at /ar-sa/ and /en-sa/, so this
    // has to be a direct link rather than routed through the localization form)
    var ksaLink = document.getElementById('ksa-country-link');
    if (ksaLink) {
      var url = lang === 'en' ? ksaLink.dataset.urlEn : ksaLink.dataset.urlAr;
      if (url) ksaLink.setAttribute('href', url);
    }
  },

  init: function() {
    var self = this;
    document.querySelectorAll('.lang-btn').forEach(function(btn) {
      btn.addEventListener('click', function() { self.set(btn.dataset.lang); });
      btn.classList.toggle('active', btn.dataset.lang === self.current);
    });
    // Sync the KSA link on initial load too
    var ksaLink = document.getElementById('ksa-country-link');
    if (ksaLink) {
      var url = self.current === 'en' ? ksaLink.dataset.urlEn : ksaLink.dataset.urlAr;
      if (url) ksaLink.setAttribute('href', url);
    }
  }
};

// ── BNPL CALCULATOR ───────────────────────────────────────────────────────────────────
// ── FILTER TABS ───────────────────────────────────────────────────────────────────────
window.TajdeedFilters = {
  init: function() {
    document.querySelectorAll('.filter-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        var group = tab.closest('.filter-tabs');
        if (!group) return;
        group.querySelectorAll('.filter-tab').forEach(function(t) { t.classList.remove('active'); });
        tab.classList.add('active');
        // Filter products
        var filter = tab.dataset.filter || 'all';
        document.querySelectorAll('.product-card[data-filter]').forEach(function(card) {
          if (filter === 'all') {
            card.style.display = '';
          } else {
            var cardFilter = card.dataset.filter || '';
            card.style.display = cardFilter.includes(filter) ? '' : 'none';
          }
        });
      });
    });
  }
};

// ── CART (AJAX) ─────────────────────────────────────────────────────────────────────────────
window.TajdeedCart = {
  addItem: function(variantId, quantity, btn) {
    quantity = quantity || 1;
    if (btn) {
      btn.disabled = true;
      btn.dataset.origText = btn.innerHTML;
      btn.innerHTML = '<span class="ar-inline">جاري الإضافة...</span><span class="en-inline">Adding...</span>';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status) {
        TajdeedCart.showNotification(
          (window.TajdeedLang.current === 'ar' ? '❌ خطأ: ' : '❌ Error: ') + (data.description || data.message), 'error'
        );
      } else {
        TajdeedCart.updateCount();
        TajdeedCart.showNotification(
          window.TajdeedLang.current === 'ar' ? '✅ تمت إضافة الجهاز للسلة!' : '✅ Device added to cart!', 'success'
        );
      }
    })
    .catch(function(err) {
      console.error('Cart error:', err);
    })
    .finally(function() {
      if (btn) {
        setTimeout(function() {
          btn.disabled = false;
          btn.innerHTML = btn.dataset.origText || btn.innerHTML;
        }, 800);
      }
    });
  },

  buyNow: function(variantId, quantity, btn) {
    quantity = quantity || 1;
    if (btn) {
      btn.disabled = true;
      btn.dataset.origText = btn.innerHTML;
      btn.innerHTML = '<span class="ar-inline">جاري التحويل...</span><span class="en-inline">Redirecting...</span>';
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status) {
        TajdeedCart.showNotification(
          (window.TajdeedLang.current === 'ar' ? '❌ خطأ: ' : '❌ Error: ') + (data.description || data.message), 'error'
        );
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = btn.dataset.origText || btn.innerHTML;
        }
      } else {
        window.location.href = '/checkout';
      }
    })
    .catch(function(err) {
      console.error('Buy now error:', err);
      if (btn) {
        btn.disabled = false;
        btn.innerHTML = btn.dataset.origText || btn.innerHTML;
      }
    });
  },

  updateCount: function() {
    fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count-badge').forEach(function(el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    });
  },

  showNotification: function(msg, type) {
    var el = document.getElementById('cart-notification');
    if (!el) return;
    el.textContent = msg;
    el.className = 'cart-notification show';
    if (type === 'error') el.style.borderColor = 'var(--red)';
    else el.style.borderColor = 'var(--emerald-d)';
    setTimeout(function() { el.classList.remove('show'); }, 3000);
  },

  init: function() {
    this.updateCount();
    document.querySelectorAll('[data-add-to-cart]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId || btn.dataset.addToCart;
        TajdeedCart.addItem(variantId, 1, btn);
      });
    });
    document.querySelectorAll('[data-buy-now]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId || btn.dataset.buyNow;
        TajdeedCart.buyNow(variantId, 1, btn);
      });
    });
  }
};

// ── GALLERY (Product Page) ────────────────────────────────────────────────────────────
window.TajdeedGallery = {
  init: function() {
    document.querySelectorAll('.gallery-thumb').forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        var main = thumb.closest('.product-gallery').querySelector('.product-gallery-main');
        if (!main) return;
        var src = thumb.dataset.src;
        var alt = thumb.dataset.alt || '';
        if (src) {
          var img = main.querySelector('img');
          if (img) { img.src = src; img.alt = alt; }
          else { main.innerHTML = '<img src="' + src + '" alt="' + alt + '" loading="lazy">'; }
        }
        thumb.closest('.gallery-thumbs').querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }
};

// ── VARIANT SELECTOR ───────────────────────────────────────────────────────────────────────
window.TajdeedVariants = {
  init: function() {
    document.querySelectorAll('.variant-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.variant-options');
        if (group) {
          group.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
        }
        var variantId = btn.dataset.variantId;
        var price     = btn.dataset.price;
        var compare   = btn.dataset.comparePrice;
        if (variantId) {
          document.querySelectorAll('[data-add-to-cart], [data-variant-id]').forEach(function(el) {
            el.dataset.variantId = variantId;
          });
        }
        if (price) {
          var cur = document.querySelector('.product-price-block .current-price');
          if (cur) cur.textContent = price;
        }
      });
    });
  }
};

// ── WISHLIST (localStorage) ───────────────────────────────────────────────────────
window.TajdeedWishlist = {
  getList: function() { return JSON.parse(localStorage.getItem('tajdeed-wishlist') || '[]'); },
  toggle: function(productId, btn) {
    var list = this.getList();
    var idx  = list.indexOf(String(productId));
    if (idx > -1) {
      list.splice(idx, 1);
      if (btn) btn.style.color = '';
    } else {
      list.push(String(productId));
      if (btn) btn.style.color = 'var(--red)';
    }
    localStorage.setItem('tajdeed-wishlist', JSON.stringify(list));
  },
  init: function() {
    var list = this.getList();
    var self = this;
    document.querySelectorAll('.btn-wishlist').forEach(function(btn) {
      var id = btn.dataset.productId;
      if (id && list.includes(String(id))) btn.style.color = 'var(--red)';
      btn.addEventListener('click', function(e) { e.preventDefault(); self.toggle(id, btn); });
    });
  }
};

// ── INIT ON DOM READY ─────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  TajdeedLang.init();
  TajdeedFilters.init();
  TajdeedCart.init();
  TajdeedGallery.init();
  TajdeedVariants.init();
  TajdeedWishlist.init();
  TajdeedConditionGuide.init();
  TajdeedFAQ.init();
  TajdeedMobileMenu.init();
});


// ── MOBILE MENU ───────────────────────────────────────────────────────────────────────────
window.TajdeedMobileMenu = {
  open: function() {
    var nav = document.getElementById('mobile-nav');
    var btn = document.getElementById('hamburger-btn');
    if (nav) nav.classList.add('open');
    if (btn) btn.classList.add('open');
    document.body.style.overflow = 'hidden';
  },
  close: function() {
    var nav = document.getElementById('mobile-nav');
    var btn = document.getElementById('hamburger-btn');
    if (nav) nav.classList.remove('open');
    if (btn) btn.classList.remove('open');
    document.body.style.overflow = '';
  },
  init: function() {
    var self = this;
    var btn = document.getElementById('hamburger-btn');
    if (btn) btn.addEventListener('click', function() { self.open(); });
    var overlay = document.getElementById('mobile-nav-overlay');
    if (overlay) overlay.addEventListener('click', function() { self.close(); });
    var closeBtn = document.getElementById('mn-close-btn');
    if (closeBtn) closeBtn.addEventListener('click', function() { self.close(); });
    document.querySelectorAll('.mn-lang-btn').forEach(function(b) {
      b.addEventListener('click', function() {
        TajdeedLang.set(b.dataset.lang);
        document.querySelectorAll('.mn-lang-btn').forEach(function(x) { x.classList.remove('active'); });
        b.classList.add('active');
      });
    });
  }
};

// ── PRODUCT OPTION SELECTOR (Storage / Condition / Colour rows) ───────────────
window.TajdeedVariantSelector = {
  variants: [],
  selectedOptions: [],

  init: function() {
    var container = document.getElementById('variant-selector');
    if (!container) return;

    var jsonEl = document.getElementById('product-variants-json');
    if (!jsonEl) return;
    try {
      this.variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error('Variant JSON parse error', e);
      return;
    }

    // Build initial selectedOptions array from currently-selected buttons
    var optionRows = container.querySelectorAll('.option-row');
    this.selectedOptions = new Array(optionRows.length).fill(null);
    optionRows.forEach(function(row, idx) {
      var selectedBtn = row.querySelector('.variant-btn.selected');
      if (selectedBtn) {
        this.selectedOptions[idx] = selectedBtn.dataset.value;
      }
    }.bind(this));

    var self = this;
    container.querySelectorAll('.variant-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (btn.disabled) return;
        var optIdx = parseInt(btn.dataset.optionIndex, 10) - 1;
        self.selectedOptions[optIdx] = btn.dataset.value;

        // Update active state within this row only
        var row = btn.closest('.option-row');
        row.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('selected'); });
        btn.classList.add('selected');

        // Update the "current value" label next to option name
        var label = row.querySelector('.option-current-value');
        if (label) label.textContent = btn.dataset.value;

        self.updateMatchedVariant();
      });
    });

    this.updateMatchedVariant();
  },

  updateMatchedVariant: function() {
    var match = this.variants.find(function(v) {
      var opts = [v.option1, v.option2, v.option3];
      return this.selectedOptions.every(function(val, idx) {
        return val === null || opts[idx] === val;
      });
    }.bind(this));

    if (!match) return;

    // Update price
    var priceEl = document.querySelector('.product-price-block .current-price');
    if (priceEl) priceEl.textContent = this.formatMoney(match.price);

    var compareEl = document.querySelector('.product-price-block .compare-price');
    var discountEl = document.querySelector('.product-price-block .discount-chip');
    if (match.compare_at_price && match.compare_at_price > match.price) {
      if (compareEl) { compareEl.textContent = this.formatMoney(match.compare_at_price); compareEl.style.display = ''; }
      if (discountEl) {
        var pct = Math.round(((match.compare_at_price - match.price) / match.compare_at_price) * 100);
        var arSpan = discountEl.querySelector('.ar-inline');
        var enSpan = discountEl.querySelector('.en-inline');
        if (arSpan) arSpan.textContent = '-' + pct + '% عن الجديد';
        if (enSpan) enSpan.textContent = '-' + pct + '% vs new';
        discountEl.style.display = '';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (discountEl) discountEl.style.display = 'none';
    }

    // Update battery health display (variant-level metafield, live per selection)
    if (match.battery_health !== null && match.battery_health !== undefined) {
      var batteryInt = parseInt(match.battery_health, 10);
      var fillEl = document.getElementById('pdp-battery-fill');
      var arVal = document.getElementById('pdp-battery-value-ar');
      var enVal = document.getElementById('pdp-battery-value-en');
      if (fillEl) {
        fillEl.style.width = batteryInt + '%';
        fillEl.classList.remove('battery-high', 'battery-med', 'battery-low');
        if (batteryInt >= 85) fillEl.classList.add('battery-high');
        else if (batteryInt >= 70) fillEl.classList.add('battery-med');
        else fillEl.classList.add('battery-low');
      }
      if (arVal) arVal.textContent = batteryInt;
      if (enVal) enVal.textContent = batteryInt;
    }

    // Update condition-guide "current grade" tag if Condition changed
    var conditionValue = match.option1;
    var optionRowsForCondition = document.querySelectorAll('.option-row');
    optionRowsForCondition.forEach(function(row) {
      if (row.dataset.optionName === 'Condition' || row.dataset.optionName === 'الحالة') {
        var idx = parseInt(row.dataset.optionIndex, 10) - 1;
        conditionValue = [match.option1, match.option2, match.option3][idx];
      }
    });
    if (conditionValue) {
      var cgRows = document.querySelectorAll('.cg-grade-row');
      cgRows.forEach(function(row) {
        var chip = row.querySelector('.cg-grade-chip');
        var existingTag = row.querySelector('.cg-current-tag');
        if (existingTag) existingTag.remove();
        if (chip && chip.textContent.trim() === conditionValue) {
          var batteryLine = row.querySelector('.cg-grade-battery');
          if (batteryLine) {
            var tag = document.createElement('span');
            tag.className = 'cg-current-tag';
            tag.innerHTML = '<span class="ar-inline">جهازك</span><span class="en-inline">Your device</span>';
            batteryLine.appendChild(tag);
          }
        }
      });
    }

    // Update BNPL hint (3-month estimate)
    var bnplStrong = document.querySelector('.product-price-block .bnpl-hint strong');
    if (bnplStrong) {
      var monthly = Math.ceil(match.price / 3 / 100); // price is in cents
      bnplStrong.textContent = this.formatMoney(monthly * 100);
    }

    // Update Add to Cart button + disabled state
    var atc = document.querySelector('.product-atc');
    if (atc) {
      atc.dataset.variantId = match.id;
      atc.dataset.addToCart = match.id;
      if (!match.available) {
        atc.disabled = true;
        atc.innerHTML = '<span class="ar-inline">نفذت الكمية</span><span class="en-inline">Sold Out</span>';
      } else {
        atc.disabled = false;
        atc.innerHTML = '🛒 <span class="ar-inline">أضف للسلة</span><span class="en-inline">Add to Cart</span>';
      }
    }

    // Keep the hidden native product form (Apple Pay / Google Pay express checkout)
    // pointed at whichever variant is currently selected in the visible UI
    var nativeVariantInput = document.getElementById('native-variant-id');
    if (nativeVariantInput) {
      nativeVariantInput.value = match.id;
      // Nudge the payment button web component to re-evaluate the new variant/price
      nativeVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Update featured image if this variant has its own image assigned
    if (match.featured_image && match.featured_image.src) {
      var newSrc = this.resizeShopifyImage(match.featured_image.src, 800);
      var mainImg = document.getElementById('gallery-main-img');
      if (mainImg) mainImg.src = newSrc;

      // Highlight the matching thumbnail if one exists for this image
      var thumbs = document.querySelectorAll('.gallery-thumb');
      thumbs.forEach(function(t) {
        var thumbImg = t.querySelector('img');
        var matches = thumbImg && thumbImg.dataset.imageId === String(match.featured_image.id);
        t.classList.toggle('active', !!matches);
      });
    }

    // Disable option combinations that don't exist (basic check)
    this.updateDisabledStates();
  },

  updateDisabledStates: function() {
    var self = this;
    document.querySelectorAll('.option-row').forEach(function(row) {
      var optIdx = parseInt(row.dataset.optionIndex, 10) - 1;
      row.querySelectorAll('.variant-btn').forEach(function(btn) {
        var testOptions = self.selectedOptions.slice();
        testOptions[optIdx] = btn.dataset.value;
        var exists = self.variants.some(function(v) {
          var opts = [v.option1, v.option2, v.option3];
          return testOptions.every(function(val, idx) {
            return val === null || opts[idx] === val;
          });
        });
        btn.disabled = !exists;
      });
    });
  },

  formatMoney: function(cents) {
    // Uses the store's actual money format (Settings → General → Store currency formatting),
    // exposed globally as Shopify.money_format in theme.liquid. This automatically reflects
    // the visitor's active currency once Shopify Markets is configured — no hardcoded currency.
    var format = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }

    var value = '';
    var centsWhole = Math.round(cents);
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    var placeholder = match ? match[1] : 'amount';

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(centsWhole, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(centsWhole, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(centsWhole, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(centsWhole, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(centsWhole, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(centsWhole, 0, ' ', '');
        break;
      default:
        value = formatWithDelimiters(centsWhole, 2);
    }

    return format.replace(placeholderRegex, value);
  },

  resizeShopifyImage: function(url, width) {
    // Shopify CDN URLs: https://cdn.shopify.com/.../image.png?v=123
    // Insert _{width}x before the file extension, keep query string intact
    if (!url) return url;
    var parts = url.split('?');
    var base = parts[0];
    var query = parts[1] ? '?' + parts[1] : '';
    var dotIndex = base.lastIndexOf('.');
    if (dotIndex === -1) return url;
    return base.slice(0, dotIndex) + '_' + width + 'x' + base.slice(dotIndex) + query;
  }
};

// ── CONDITION GUIDE MODAL (Product Page) ─────────────────────────────────────────
window.TajdeedConditionGuide = {
  init: function() {
    var openBtn = document.getElementById('condition-guide-open');
    var closeBtn = document.getElementById('condition-guide-close');
    var overlay = document.getElementById('condition-guide-overlay');
    if (!openBtn || !overlay) return;

    function open() { overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function close() { overlay.classList.remove('open'); document.body.style.overflow = ''; }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) close();
    });
  }
};

// ── FAQ ACCORDION (Product Page) ────────────────────────────────────────────────────
window.TajdeedFAQ = {
  init: function() {
    document.querySelectorAll('.faq-item').forEach(function(item) {
      var question = item.querySelector('.faq-question');
      if (!question) return;
      question.addEventListener('click', function() {
        var wasOpen = item.classList.contains('open');
        item.closest('.pdp-faq').querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
        if (!wasOpen) item.classList.add('open');
      });
    });
  }
};

// ── HERO SLIDESHOW ───────────────────────────────────────────────────────────────────
window.TajdeedHeroSlider = {
  init: function() {
    var hero = document.getElementById('hero');
    if (!hero) return;

    var slides = hero.querySelectorAll('.hero-slide');
    if (slides.length <= 1) return; // nothing to slide

    var dots = hero.querySelectorAll('.hero-dot');
    var prevBtn = document.getElementById('hero-prev');
    var nextBtn = document.getElementById('hero-next');
    var current = 0;
    var total = slides.length;
    var autoplayMs = parseInt(hero.dataset.autoplayMs, 10) || 6000;
    var timer = null;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function getSlideVideo(slide) {
      return slide ? slide.querySelector('.hero-visual-video') : null;
    }

    var VIDEO_SESSION_KEY = 'tajdeed_hero_video_played';
    function hasVideoPlayedThisSession() {
      try { return sessionStorage.getItem(VIDEO_SESSION_KEY) === '1'; } catch (e) { return false; }
    }
    function markVideoPlayedThisSession() {
      try { sessionStorage.setItem(VIDEO_SESSION_KEY, '1'); } catch (e) {}
    }

    function goTo(index) {
      index = ((index % total) + total) % total; // wrap both directions

      // pause/reset any video on the slide we're leaving
      var leavingVideo = getSlideVideo(slides[current]);
      if (leavingVideo) {
        leavingVideo.pause();
        leavingVideo.currentTime = 0;
      }

      slides[current].classList.remove('active');
      if (dots[current]) { dots[current].classList.remove('active'); dots[current].setAttribute('aria-selected', 'false'); }
      current = index;
      slides[current].classList.add('active');
      if (dots[current]) { dots[current].classList.add('active'); dots[current].setAttribute('aria-selected', 'true'); }

      // start the video on the slide we're entering
      var enteringVideo = getSlideVideo(slides[current]);
      if (enteringVideo) {
        // after the first time this video has played (with or without sound) in this
        // browser session, force it muted on every subsequent loop so sound doesn't
        // keep surprising the visitor each time the carousel comes back around
        if (hasVideoPlayedThisSession()) {
          enteringVideo.muted = true;
          var muteBtn = slides[current].querySelector('.hero-video-mute-toggle');
          if (muteBtn) {
            var mIcon = muteBtn.querySelector('.hvmt-muted');
            var uIcon = muteBtn.querySelector('.hvmt-unmuted');
            if (mIcon) mIcon.style.display = 'inline';
            if (uIcon) uIcon.style.display = 'none';
          }
        } else {
          markVideoPlayedThisSession();
        }
        enteringVideo.play().catch(function() {});
      }
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (reducedMotion) return;
      stopAutoplay();
      var activeVideo = getSlideVideo(slides[current]);
      if (activeVideo) {
        // video slides advance when the video actually finishes, not on a fixed timer
        var onEnded = function() {
          activeVideo.removeEventListener('ended', onEnded);
          next();
          startAutoplay();
        };
        activeVideo.addEventListener('ended', onEnded);
        return;
      }
      timer = setInterval(next, autoplayMs);
    }
    function stopAutoplay() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (nextBtn) nextBtn.addEventListener('click', function() { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function() { prev(); startAutoplay(); });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); startAutoplay(); });
    });

    // Mute/unmute toggle for any hero video (event delegation)
    hero.addEventListener('click', function(e) {
      var btn = e.target.closest ? e.target.closest('.hero-video-mute-toggle') : null;
      if (!btn) return;
      var video = btn.parentElement ? btn.parentElement.querySelector('.hero-visual-video') : null;
      if (!video) return;
      video.muted = !video.muted;
      var mutedIcon = btn.querySelector('.hvmt-muted');
      var unmutedIcon = btn.querySelector('.hvmt-unmuted');
      if (video.muted) {
        mutedIcon.style.display = 'inline';
        unmutedIcon.style.display = 'none';
      } else {
        mutedIcon.style.display = 'none';
        unmutedIcon.style.display = 'inline';
      }
    });

    // Don't let manual nav interrupt video slides awkwardly, but still allow it
    hero.addEventListener('mouseenter', function() {
      if (!getSlideVideo(slides[current])) stopAutoplay();
    });
    hero.addEventListener('mouseleave', startAutoplay);
    hero.addEventListener('focusin', function() {
      if (!getSlideVideo(slides[current])) stopAutoplay();
    });
    hero.addEventListener('focusout', startAutoplay);

    // Touch swipe support
    var touchStartX = 0;
    var touchEndX = 0;
    hero.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoplay();
    }, { passive: true });
    hero.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      var delta = touchEndX - touchStartX;
      if (Math.abs(delta) > 40) {
        var isRtl = document.documentElement.getAttribute('dir') === 'rtl';
        if (delta < 0) { isRtl ? prev() : next(); }
        else { isRtl ? next() : prev(); }
      }
      startAutoplay();
    }, { passive: true });

    // kick off the very first slide's video if it starts as the active one
    var firstVideo = getSlideVideo(slides[current]);
    if (firstVideo) {
      if (hasVideoPlayedThisSession()) {
        firstVideo.muted = true;
        var initMuteBtn = slides[current].querySelector('.hero-video-mute-toggle');
        if (initMuteBtn) {
          var initMIcon = initMuteBtn.querySelector('.hvmt-muted');
          var initUIcon = initMuteBtn.querySelector('.hvmt-unmuted');
          if (initMIcon) initMIcon.style.display = 'inline';
          if (initUIcon) initUIcon.style.display = 'none';
        }
      } else {
        markVideoPlayedThisSession();
      }
      firstVideo.play().catch(function() {});
    }

    startAutoplay();
  }
};

// ── SAR DISPLAY CONVERSION (Saudi Arabia visitors only) ────────────────────────
// Shows an approximate SAR price alongside the real AED price/charge.
// IMPORTANT: this is DISPLAY ONLY — actual checkout still charges in AED.
// Fixed rate reflects the real AED/SAR USD-peg relationship (both currencies
// are pegged to USD), so it's stable and won't need frequent updates.
window.TajdeedSarDisplay = {
  RATE: 1.02, // 1 AED ≈ 1.02 SAR

  parseAmount: function(text) {
    var cleaned = text.replace(/[^0-9.]/g, '');
    var value = parseFloat(cleaned);
    return isNaN(value) ? null : value;
  },

  formatSar: function(value) {
    var rounded = Math.round(value * 100) / 100;
    return '≈ SAR ' + rounded.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  },

  convertElement: function(el) {
    var amount = this.parseAmount(el.textContent);
    if (amount === null) return;
    var existing = el.nextElementSibling;
    if (existing && existing.classList && existing.classList.contains('price-sar-approx')) {
      var newText = this.formatSar(amount * this.RATE);
      if (existing.textContent !== newText) existing.textContent = newText;
      return;
    }
    var sarSpan = document.createElement('span');
    sarSpan.className = 'price-sar-approx';
    sarSpan.textContent = this.formatSar(amount * this.RATE);
    el.insertAdjacentElement('afterend', sarSpan);
  },

  scan: function() {
    var self = this;
    document.querySelectorAll('.current-price, .compare-price').forEach(function(el) {
      self.convertElement(el);
    });
  },

  init: function() {
    if (window.TajdeedCountryCode !== 'SA') return;
    this.scan();
    var self = this;
    var scheduled = false;
    var observer = new MutationObserver(function() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function() {
        self.scan();
        scheduled = false;
      }, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
};

document.addEventListener('DOMContentLoaded', function() {
  if (window.TajdeedVariantSelector) TajdeedVariantSelector.init();
  if (window.TajdeedHeroSlider) TajdeedHeroSlider.init();
  if (window.TajdeedSarDisplay) TajdeedSarDisplay.init();

  // Custom country dropdown (UAE + KSA link toggle)
  var countryBtn = document.getElementById('country-dropdown-btn');
  var countryMenu = document.getElementById('country-dropdown-menu');
  if (countryBtn && countryMenu) {
    countryBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = countryMenu.classList.toggle('open');
      countryBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    document.addEventListener('click', function() {
      countryMenu.classList.remove('open');
      countryBtn.setAttribute('aria-expanded', 'false');
    });
  }
});
